/**
 * User Preferences - Persisted dashboard view + filters.
 */
import { z } from 'zod';
import { UserId } from '../types/branded';
import { DashboardView } from '../types/enums';

export const PreferredContactMethodSchema = z.enum(['email', 'phone', 'sms', 'portal']);
export type PreferredContactMethod = z.infer<typeof PreferredContactMethodSchema>;

export const UserPreferencesSchema = z.object({
  userId: UserId,
  defaultView: DashboardView.default('list'),
  filters: z.record(z.string(), z.unknown()).optional(),
  darkModeEnabled: z.boolean().default(false),
  preferredContactMethod: PreferredContactMethodSchema.default('email'),
  updatedAt: z.number().int(),
});
export type UserPreferences = z.infer<typeof UserPreferencesSchema>;

export const UpdateUserPreferencesInputSchema = z.object({
  defaultView: DashboardView.optional(),
  filters: z.record(z.string(), z.unknown()).optional(),
  darkModeEnabled: z.boolean().optional(),
  preferredContactMethod: PreferredContactMethodSchema.optional(),
});
export type UpdateUserPreferencesInput = z.infer<typeof UpdateUserPreferencesInputSchema>;
